<template>
    <div v-if="category">
        <h2 class="mt-4 mb-2 text-2xl">
            {{ category.name }}
        </h2>
        <div class="md:flex gap-8">
            <div class="md:w-1/4 mb-8">
                <nav class="md:flex flex-col gap-2">
                    <nuxt-link
                        v-for="article in category.articles"
                        :key="article.articles_id.id"
                        :to="`/help/${category.slug}/${article.articles_id.slug}`"
                        class="px-4 py-2 flex justify-between items-center"
                        :class="activeArticleSlug === article.articles_id.slug ? 'bg-green-lightest' : 'bg-blue-100'"
                    >
                        {{ article.articles_id.title }}
                        <ChevronRight class="ml-8 w-4" />
                    </nuxt-link>
                </nav>
            </div>
            <div class="md:w-3/4">
                <NuxtChild :key="$route.params.article" />
            </div>
        </div>
    </div>

</template>
<script>
import ChevronRight from '~/static/fonts/LineIcons/chevron-right.svg';

export default {
    components: {
        ChevronRight,
    },
    computed: {
        category() {
            return this.$store.getters['help/activeCategory'];
        },
        activeArticleSlug() {
            if (this.$store.getters['help/activeArticle']) {
                return this.$store.getters['help/activeArticle'].slug;
            }

            return null;
        },
    },
    mounted() {
        this.$store.dispatch('help/setActiveCategory', this.$route.params.category);
    },
};
</script>
